module.exports = __webpack_public_path__ + "img/choix.c08e75a0.png";